/*
 * Yêu cầu báo giá (RFQ) — chữ trên màn hình. 19/09/2026: SOURCING-R01..R03 đã chốt theo chuẩn (anh Toàn duyệt, khách bác lại được) — bốn
 * quy tắc trong mục gập "Quy tắc áp dụng"; bỏ thẻ vàng "chờ khách xác nhận"; chữ nói "yêu cầu mua / đơn mua" thay "PR / PO" (bản in giữ
 * nhãn tham chiếu cũ). Trang Đơn mua hàng, Yêu cầu mua hàng và bản in đơn mua dùng lại vài khoá ở đây — giữ nguyên khoá.
 */
export const sourcingEn = {
  pProcess: "P-Process / supplier LOT traceability required",
  pProcessNote: "Inherited from source demand. Keep supplier LOT traceability at receipt and subsequent steps.",
  notActionable: "This purchase requisition is not open for purchasing. The remaining column is unallocated quantity, not authorisation to buy.",
  datesError: "Quote dates used for award and actual delivery dates cannot be in the future.",
  progress: "Ordering progress",
  allocated: "On purchase orders (not cancelled)",
  remaining: "Left to order",
  received: "Received (confirmed warehouse receipts)",
  remainingToReceive: "Left to receive against the purchase orders",
  progressHint: "A cancelled purchase order releases its allocation. Left to receive compares confirmed warehouse receipts with the purchase-order quantity; it is not a payment result.",
  printRfq: "Ref RFQ",
  printPr: "Ref PR",
  printQuote: "Supplier quote",
  orderQuantity: "Ordered quantity",
  orderPrice: "Purchase unit price",
  orderTotal: "Purchase order total",
  orderExpected: "Expected delivery date",
  requestIncomplete: "Enter a reply deadline and a reference of at least 5 characters before starting to collect quotes.",
  taxAmount: "Tax amount",
  title: "Requests for quotation (RFQ)",
  intro: "Ask suppliers to quote for an approved purchase requisition, record the quotes received, compare them and choose one to create a draft purchase order. The system never emails suppliers and never picks the cheapest by itself.",
  new: "New RFQ",
  back: "RFQ list",
  source: "Source purchase requisition",
  sourceSearch: "Search purchase requisition / reason",
  load: "Load requisition lines",
  requestDate: "Request date",
  respondBy: "Reply deadline",
  reference: "Reference / specification",
  notes: "Notes",
  quantity: "RFQ quantity",
  unit: "Unit",
  remove: "Remove line",
  save: "Save draft",
  open: "Start collecting replies",
  cancel: "Cancel RFQ",
  archive: "Archive RFQ",
  Draft: "Draft",
  Open: "Collecting replies",
  Awarded: "Supplier chosen",
  Cancelled: "Cancelled",
  Archived: "Archived",
  bids: "Supplier replies",
  newBid: "Record supplier reply",
  editBid: "Revise reply",
  supplier: "Supplier",
  supplierSearch: "Search supplier",
  currency: "Currency",
  currencyHint: "Changing currency clears prices, freight and tax. Re-enter the quoted values; no FX conversion is performed.",
  quoteDate: "Quote date",
  validUntil: "Valid through",
  deliveryDate: "Promised delivery date",
  paymentTerms: "Payment terms",
  shippingMethod: "Shipping terms / method",
  freight: "Freight (in the quote currency)",
  tax: "Tax (%)",
  price: "Price per requested unit",
  suitability: "Suitability review (quality / specification)",
  Unreviewed: "Not reviewed",
  Accepted: "Suitable for purchasing",
  Rejected: "Not suitable",
  reviewBasis: "Review basis / specification reference",
  unknown: "Total incomplete",
  subtotal: "Subtotal",
  total: "Quoted total",
  expired: "Expired",
  late: "Later than the needed date",
  incomplete: "Incomplete or not eligible for award",
  award: "Choose quote & create draft purchase order",
  awardHint: "Review quantities, fees, currency, delivery and suitability. This creates a draft purchase order at the quoted prices and allocates the requisition demand — it does not send the order, move stock or approve payment.",
  reason: "Reason",
  confirm: "Confirm action",
  actionHint: "History is kept. Cancelling an RFQ does not cancel its purchase order — resolve the linked order first.",
  viewOrder: "View purchase order",
  sourceTag: "From RFQ",
  lockedOrder: "This purchase order came from a chosen quote: prices, supplier and lines are fixed. Logistics can be edited below; to change commercial terms, cancel the order and choose again or issue a new RFQ.",
  saveLogistics: "Save logistics",
  status: "Status",
  setStatus: "Record status",
  archiveOrder: "Archive purchase order",
  actualDate: "Actual delivery date",
  orderReason: "Reason for logistics/status change",
  history: "History",
  Created: "Created",
  Edited: "Draft edited",
  Opened: "Replies opened",
  BidRecorded: "Reply recorded",
  BidRevised: "Reply revised",
  OrderUpdated: "Logistics updated",
  OrderStatus: "Purchase order status recorded",
  OrderArchived: "Purchase order archived",
  sourceChanged: "Requisition status or revision, product unit or unallocated quantity changed. Review the source before proceeding.",
  error: "Unable to load or save sourcing data.",
  invalid: "Review required fields, dates, quantities and prices. Use a decimal point without grouping.",
  changed: "The RFQ, quote or purchase order changed. Reload before proceeding.",
  locked: "This state does not allow this action.",
  sourceError: "The source requisition, product or supplier is unavailable or no longer eligible.",
  overallocated: "The quantity exceeds what is still left to order on the requisition. Another RFQ may have used it.",
  dependency: "Resolve open RFQs, linked purchase orders or receipts before cancelling or archiving.",
  termsRequired: "Complete prices, fees, validity, delivery, payment/shipping terms and suitability review before award.",
  expiredError: "The quote validity or promised delivery date has passed. Record an updated reply.",
  orderLocked: "Use the purchase order page for RFQ orders. Chosen commercial terms cannot be edited directly.",
  unsaved: "Unsaved RFQ or reply changes will be lost.",
  rulesTitle: "Rules in force",
  rulesDecided: "Settled 19/09/2026",
  rules: {
    collect: {
      title: "How quotes are collected",
      body: "An RFQ is raised from an approved purchase requisition — all or part of its lines and quantities, never more than is left to order. The system sends nothing: purchasing sends the RFQ to suppliers and records each quote received (line prices, freight, tax, validity, delivery date, terms). A late quote can still be recorded until a choice is made. Validity and delivery are dated by the Vietnam day."
    },
    compare: {
      title: "Compared on more than price",
      body: "Total cost (goods + freight + tax) is compared within one currency — no automatic exchange; across currencies the chooser records the basis. Also weighed: delivery against the needed date (late is flagged), validity, payment terms and the suitability review (quality, specification — only \"Suitable for purchasing\" can be chosen; not a substitute for IQC). The system never picks the cheapest by itself."
    },
    award: {
      title: "At least two quotes, a reasoned choice",
      body: "A choice needs at least 2 eligible quotes; with only 1, the chooser must give a single-source reason — exclusive supplier, urgent, customer-nominated or only one reply. Each RFQ chooses one supplier and creates one draft purchase order; to split demand across suppliers, raise several RFQs from the same requisition. Choosing another supplier does not change the product's default supplier."
    },
    authority: {
      title: "Who does what",
      body: "Create to raise an RFQ and record new quotes; Edit to correct a draft, start collecting quotes, revise quotes and cancel an RFQ; Approve to choose a quote and create the draft purchase order; Delete to archive. The resulting purchase order follows the Purchase orders ticks — confirming it needs Approve there."
    }
  },
  singleSource: {
    label: "Single-source reason",
    hint: "Only {{count}} eligible quote(s) — at least 2 are needed to compare. Choose why a single supplier is used:",
    exclusive: "Exclusive — only this supplier can make it",
    urgent: "Urgent — no time to ask more suppliers",
    customerNominated: "Supplier nominated by the customer",
    onlyReply: "Only one supplier replied"
  },
  singleSourceError: "Fewer than 2 eligible quotes: choose a single-source reason before choosing.",
  singleSourceNote: "Single source: {{reason}}",
  readyCount: "Eligible quotes: {{count}}",
  lowest: "Lowest total",
  groups: {
    info: "Request for quotation",
    infoHint: "Source requisition, reply deadline, reference / specification sent to suppliers.",
    lines: "Materials to quote",
    linesHint: "All or part of what is left to order on the requisition.",
    bids: "Supplier quotes",
    bidsHint: "Sorted by total cost within each currency. Only eligible quotes can be chosen.",
    terms: "Quote",
    termsHint: "Supplier, currency, dates, terms, freight and tax.",
    review: "Suitability review",
    reviewHint: "Quality / specification against the request — must be \"Suitable for purchasing\" to be chosen. Not a substitute for IQC.",
    prices: "Line prices",
    pricesHint: "Price per requested unit, in the quote currency.",
    order: "Purchase order",
    orderHint: "Supplier, terms and lines from the chosen quote — fixed.",
    logistics: "Logistics and status",
    logisticsHint: "Expected / actual delivery, notes, order status. Confirming needs the Approve tick on Purchase orders."
  },
  choose: "Choose",
  awardReason: "Reason for the choice",
  openHint: "Start collecting quotes: the RFQ content is locked from now on. Give a reason — for example which suppliers the RFQ was sent to.",
  archiveHint: "Archive a chosen or cancelled RFQ to tidy the list; its content and history are kept.",
};
export const sourcingVi = {
  pProcess: "P-Process / yêu cầu truy vết LOT nhà cung cấp",
  pProcessNote: "Kế thừa từ nhu cầu nguồn. Giữ truy vết LOT nhà cung cấp khi nhận hàng và ở các bước sau.",
  notActionable: "Yêu cầu mua này không còn hoặc chưa đủ điều kiện mua. Cột còn lại là lượng chưa phân bổ, không phải cho phép tiếp tục mua.",
  datesError: "Không dùng ngày chào giá tương lai để chọn mua; ngày giao thực tế cũng không được ở tương lai.",
  progress: "Tiến độ đặt hàng",
  allocated: "Đã lên đơn mua (chưa huỷ)",
  remaining: "Còn phải đặt",
  received: "Đã nhận (phiếu kho đã xác nhận)",
  remainingToReceive: "Còn phải nhận so với đơn mua",
  progressHint: "Đơn mua bị huỷ trả lại lượng đã phân bổ. Còn phải nhận là phiếu kho đã xác nhận so với lượng đơn mua, không phải kết quả thanh toán.",
  printRfq: "Tham chiếu RFQ",
  printPr: "Tham chiếu PR",
  printQuote: "Chào giá nhà cung cấp",
  orderQuantity: "Số lượng đặt",
  orderPrice: "Đơn giá mua",
  orderTotal: "Tổng đơn mua",
  orderExpected: "Ngày giao dự kiến",
  requestIncomplete: "Nhập hạn nhận chào giá và tham chiếu ít nhất 5 ký tự trước khi bắt đầu thu thập giá.",
  taxAmount: "Tiền thuế",
  title: "Yêu cầu báo giá (RFQ)",
  intro: "Hỏi giá nhà cung cấp cho yêu cầu mua đã duyệt, ghi lại chào giá nhận được, so sánh rồi chọn một bên để tạo đơn mua nháp. Hệ không tự gửi thư cho nhà cung cấp và không tự chọn bên rẻ nhất.",
  new: "Tạo RFQ",
  back: "Danh sách RFQ",
  source: "Yêu cầu mua nguồn",
  sourceSearch: "Tìm yêu cầu mua / lý do",
  load: "Nạp dòng yêu cầu mua",
  requestDate: "Ngày yêu cầu",
  respondBy: "Hạn nhận chào giá",
  reference: "Tham chiếu / quy cách",
  notes: "Ghi chú",
  quantity: "Số lượng hỏi giá",
  unit: "Đơn vị",
  remove: "Bỏ dòng",
  save: "Lưu nháp",
  open: "Bắt đầu thu thập giá",
  cancel: "Huỷ RFQ",
  archive: "Lưu trữ RFQ",
  Draft: "Nháp",
  Open: "Đang thu thập giá",
  Awarded: "Đã chọn nhà cung cấp",
  Cancelled: "Đã huỷ",
  Archived: "Đã lưu trữ",
  bids: "Chào giá nhà cung cấp",
  newBid: "Ghi nhận chào giá",
  editBid: "Sửa chào giá",
  supplier: "Nhà cung cấp",
  supplierSearch: "Tìm nhà cung cấp",
  currency: "Tiền tệ",
  currencyHint: "Đổi tiền tệ sẽ xóa giá, vận chuyển và thuế đang nhập. Nhập lại theo chào giá; không tự quy đổi tỷ giá.",
  quoteDate: "Ngày chào giá",
  validUntil: "Hiệu lực đến",
  deliveryDate: "Ngày giao cam kết",
  paymentTerms: "Điều khoản thanh toán",
  shippingMethod: "Điều kiện / cách vận chuyển",
  freight: "Phí vận chuyển (theo tiền tệ chào giá)",
  tax: "Thuế (%)",
  price: "Giá mỗi đơn vị được hỏi",
  suitability: "Rà soát phù hợp (chất lượng / quy cách)",
  Unreviewed: "Chưa rà soát",
  Accepted: "Phù hợp để mua",
  Rejected: "Không phù hợp",
  reviewBasis: "Căn cứ rà soát / quy cách",
  unknown: "Chưa đủ dữ liệu tính tổng",
  subtotal: "Tiền hàng",
  total: "Tổng chào giá",
  expired: "Hết hiệu lực",
  late: "Trễ hơn ngày cần",
  incomplete: "Chưa đủ điều kiện chọn",
  award: "Chọn chào giá & tạo đơn mua nháp",
  awardHint: "Rà số lượng, phí, tiền tệ, ngày giao và mức phù hợp. Thao tác tạo đơn mua nháp đúng giá của chào giá và phân bổ nhu cầu của yêu cầu mua — chưa gửi đơn, chưa ghi kho, chưa duyệt thanh toán.",
  reason: "Lý do",
  confirm: "Thực hiện",
  actionHint: "Giữ lịch sử. Huỷ RFQ không tự huỷ đơn mua — cần xử lý đơn mua liên kết trước.",
  viewOrder: "Xem đơn mua",
  sourceTag: "Từ RFQ",
  lockedOrder: "Đơn mua này tạo từ RFQ đã chọn: giá, nhà cung cấp và dòng hàng cố định. Sửa được giao nhận bên dưới; muốn đổi điều kiện mua thì huỷ đơn rồi chọn lại hoặc lập RFQ mới.",
  saveLogistics: "Lưu thông tin giao nhận",
  status: "Trạng thái",
  setStatus: "Ghi nhận trạng thái",
  archiveOrder: "Lưu trữ đơn mua",
  actualDate: "Ngày giao thực tế",
  orderReason: "Lý do sửa giao nhận / trạng thái",
  history: "Lịch sử xử lý",
  Created: "Tạo mới",
  Edited: "Sửa nháp",
  Opened: "Bắt đầu thu thập giá",
  BidRecorded: "Ghi nhận chào giá",
  BidRevised: "Sửa chào giá",
  OrderUpdated: "Sửa giao nhận",
  OrderStatus: "Ghi trạng thái đơn mua",
  OrderArchived: "Lưu trữ đơn mua",
  sourceChanged: "Trạng thái / phiên bản yêu cầu mua, đơn vị sản phẩm hoặc lượng chưa phân bổ đã đổi. Rà nguồn trước khi tiếp tục.",
  error: "Không thể tải hoặc lưu dữ liệu hỏi giá.",
  invalid: "Kiểm tra trường bắt buộc, ngày, lượng và giá. Dùng dấu chấm thập phân, không có dấu phân nhóm.",
  changed: "RFQ, chào giá hoặc đơn mua đã thay đổi. Tải lại trước khi tiếp tục.",
  locked: "Trạng thái này không cho phép thao tác.",
  sourceError: "Yêu cầu mua, sản phẩm hoặc nhà cung cấp nguồn không còn đủ điều kiện.",
  overallocated: "Số lượng vượt phần yêu cầu mua còn phải đặt. RFQ khác có thể đã dùng nhu cầu này.",
  dependency: "Cần xử lý RFQ đang mở, đơn mua liên kết hoặc phiếu nhận trước khi huỷ / lưu trữ.",
  termsRequired: "Cần đủ giá, phí, hiệu lực, ngày giao, điều khoản thanh toán/vận chuyển và rà soát phù hợp trước khi chọn.",
  expiredError: "Chào giá hoặc ngày giao cam kết đã qua. Cần ghi nhận chào giá cập nhật.",
  orderLocked: "Dùng trang đơn mua từ RFQ. Không sửa trực tiếp điều kiện mua đã chọn.",
  unsaved: "Các thay đổi RFQ/chào giá chưa lưu sẽ bị mất.",
  rulesTitle: "Quy tắc áp dụng",
  rulesDecided: "Đã chốt 19/09/2026",
  rules: {
    collect: {
      title: "Hỏi giá thế nào",
      body: "RFQ lập từ yêu cầu mua đã duyệt — toàn bộ hay một phần dòng / lượng, không vượt phần còn phải đặt. Hệ không tự gửi thư: mua hàng gửi RFQ cho nhà cung cấp rồi ghi lại từng chào giá nhận được (giá từng dòng, phí vận chuyển, thuế, hiệu lực, ngày giao, điều khoản). Chào giá đến sau hạn vẫn ghi được cho tới khi chọn. Hiệu lực và ngày giao tính theo ngày Việt Nam."
    },
    compare: {
      title: "So sánh không chỉ theo giá",
      body: "So tổng chi phí (tiền hàng + vận chuyển + thuế) trong cùng loại tiền — không tự quy đổi tỷ giá; khác tiền tệ thì người chọn ghi căn cứ. Xét thêm ngày giao so với ngày cần (trễ thì báo), hiệu lực, điều khoản thanh toán và rà soát phù hợp (chất lượng, quy cách — phải \"Phù hợp để mua\" mới chọn được; không thay IQC). Hệ không tự chọn bên rẻ nhất."
    },
    award: {
      title: "Ít nhất hai chào giá, chọn có lý do",
      body: "Chọn khi có ít nhất 2 chào giá đủ điều kiện; chỉ có 1 thì người chọn phải nêu lý do một nhà cung cấp — độc quyền, hàng gấp, khách chỉ định hoặc chỉ một bên trả lời. Mỗi RFQ chọn một nhà cung cấp và tạo một đơn mua nháp; muốn chia nhu cầu cho nhiều nhà cung cấp thì lập nhiều RFQ từ cùng yêu cầu mua. Chọn nhà cung cấp khác không đổi nhà cung cấp mặc định của sản phẩm."
    },
    authority: {
      title: "Ai được làm gì",
      body: "Tạo để lập RFQ và ghi chào giá mới; Sửa để sửa nháp, bắt đầu thu thập giá, sửa chào giá, huỷ RFQ; Duyệt để chọn chào giá và tạo đơn mua nháp; Xóa để lưu trữ. Đơn mua tạo ra theo ô của menu Đơn mua hàng — xác nhận đơn cần ô Duyệt ở đó."
    }
  },
  singleSource: {
    label: "Lý do một nhà cung cấp",
    hint: "Chỉ có {{count}} chào giá đủ điều kiện — cần ít nhất 2 để so sánh. Chọn lý do chỉ dùng một nhà cung cấp:",
    exclusive: "Độc quyền — chỉ nhà cung cấp này làm được",
    urgent: "Hàng gấp, không kịp hỏi thêm",
    customerNominated: "Khách chỉ định nhà cung cấp",
    onlyReply: "Chỉ một nhà cung cấp trả lời"
  },
  singleSourceError: "Chỉ có dưới 2 chào giá đủ điều kiện: chọn lý do một nhà cung cấp trước khi chọn.",
  singleSourceNote: "Một nhà cung cấp: {{reason}}",
  readyCount: "Chào giá đủ điều kiện: {{count}}",
  lowest: "Tổng thấp nhất",
  groups: {
    info: "Yêu cầu báo giá",
    infoHint: "Yêu cầu mua nguồn, hạn nhận chào giá, tham chiếu / quy cách gửi nhà cung cấp.",
    lines: "Vật tư hỏi giá",
    linesHint: "Toàn bộ hay một phần lượng còn phải đặt của yêu cầu mua.",
    bids: "Chào giá nhà cung cấp",
    bidsHint: "Xếp theo tổng chi phí trong từng loại tiền. Chỉ chào giá đủ điều kiện mới chọn được.",
    terms: "Chào giá",
    termsHint: "Nhà cung cấp, tiền tệ, ngày, điều khoản, phí vận chuyển và thuế.",
    review: "Rà soát phù hợp",
    reviewHint: "Chất lượng / quy cách so với yêu cầu — phải \"Phù hợp để mua\" mới chọn được. Không thay IQC.",
    prices: "Giá từng dòng",
    pricesHint: "Giá cho mỗi đơn vị được hỏi, theo tiền tệ của chào giá.",
    order: "Đơn mua",
    orderHint: "Nhà cung cấp, điều khoản và dòng hàng theo chào giá đã chọn — cố định.",
    logistics: "Giao nhận và trạng thái",
    logisticsHint: "Ngày giao dự kiến / thực tế, ghi chú, trạng thái đơn mua. Xác nhận đơn cần ô Duyệt ở menu Đơn mua hàng."
  },
  choose: "Chọn",
  awardReason: "Lý do chọn",
  openHint: "Bắt đầu nhận chào giá: nội dung RFQ khoá lại, không sửa được nữa. Ghi lý do — ví dụ đã gửi RFQ cho những nhà cung cấp nào.",
  archiveHint: "Lưu trữ RFQ đã chọn hoặc đã huỷ cho gọn danh sách; nội dung và lịch sử vẫn giữ.",
};
export const sourcingZh = {
  pProcess: "P-Process／需要供应商LOT追溯",
  pProcessNote: "继承来源需求，收货及后续步骤须保留供应商LOT追溯。",
  notActionable: "此采购申请目前不可采购。“剩余”列仅表示未分配量，并非采购授权。",
  datesError: "选用报价的报价日期与实际交货日期不得晚于今天。",
  progress: "下单进度",
  allocated: "已列入采购单（未取消）",
  remaining: "尚需下单",
  received: "已收货（已确认入库）",
  remainingToReceive: "采购单尚待收货",
  progressHint: "采购单取消会释放分配量。尚待收货为采购单数量减去已确认入库数量，不代表付款结果。",
  printRfq: "RFQ参考",
  printPr: "PR参考",
  printQuote: "供应商报价",
  orderQuantity: "订购数量",
  orderPrice: "采购单价",
  orderTotal: "采购单总额",
  orderExpected: "预计交货日",
  requestIncomplete: "开始收集报价前，请输入报价截止日及至少5字符的参考。",
  taxAmount: "税额",
  title: "询价单（RFQ）",
  intro: "为已审核的采购申请向供应商询价，记录收到的报价，比较后选定一家以创建采购单草稿。系统不会自动发信给供应商，也不会自动选最便宜的一家。",
  new: "新增RFQ",
  back: "RFQ列表",
  source: "来源采购申请",
  sourceSearch: "搜索采购申请／原因",
  load: "加载申请明细",
  requestDate: "需求日期",
  respondBy: "报价截止日",
  reference: "参考／规格",
  notes: "备注",
  quantity: "询价数量",
  unit: "单位",
  remove: "移除行",
  save: "保存草稿",
  open: "开始收集报价",
  cancel: "取消RFQ",
  archive: "归档RFQ",
  Draft: "草稿",
  Open: "收集中",
  Awarded: "已选定供应商",
  Cancelled: "已取消",
  Archived: "已归档",
  bids: "供应商回复",
  newBid: "记录报价",
  editBid: "修订报价",
  supplier: "供应商",
  supplierSearch: "搜索供应商",
  currency: "币种",
  currencyHint: "变更币种会清除价格、运费及税率。请按报价重新输入，不会自动换算汇率。",
  quoteDate: "报价日期",
  validUntil: "有效期限",
  deliveryDate: "承诺交货日",
  paymentTerms: "付款条件",
  shippingMethod: "运送条件／方式",
  freight: "运费（报价币种）",
  tax: "税率（%）",
  price: "每询价单位价格",
  suitability: "适用性审查（质量／规格）",
  Unreviewed: "未审查",
  Accepted: "适合采购",
  Rejected: "不适合",
  reviewBasis: "审查依据／规格",
  unknown: "总额数据未齐",
  subtotal: "货款",
  total: "报价总额",
  expired: "已过期",
  late: "晚于需求日期",
  incomplete: "尚不符合选用条件",
  award: "选定报价并创建采购单草稿",
  awardHint: "请检查数量、费用、币种、交期与适用性。此操作按报价价格创建采购单草稿并分配申请需求——不发送采购单、不改变库存、不审核付款。",
  reason: "原因",
  confirm: "执行",
  actionHint: "保留历史。取消询价单不会自动取消采购单，请先处理关联的采购单。",
  viewOrder: "查看采购单",
  sourceTag: "来自 RFQ",
  lockedOrder: "此采购单来自已选定的报价：价格、供应商及明细固定。可于下方修改物流信息；如要变更商业条件，请取消采购单后重新选定或创建新询价单。",
  saveLogistics: "保存物流信息",
  status: "状态",
  setStatus: "记录状态",
  archiveOrder: "归档采购单",
  actualDate: "实际交货日",
  orderReason: "物流／状态变更原因",
  history: "处理历史",
  Created: "创建",
  Edited: "修改草稿",
  Opened: "开始收集",
  BidRecorded: "记录报价",
  BidRevised: "修订报价",
  OrderUpdated: "更新物流",
  OrderStatus: "记录采购单状态",
  OrderArchived: "归档采购单",
  sourceChanged: "采购申请状态／版本、产品单位或未分配数量已变更，请先检查来源。",
  error: "无法加载或保存询价信息。",
  invalid: "请检查必填字段、日期、数量及价格，使用小数点且不要千位分隔符。",
  changed: "询价单、报价或采购单已变更，请重新加载。",
  locked: "目前状态不允许此操作。",
  sourceError: "来源采购申请、产品或供应商已不符合资格。",
  overallocated: "数量超过采购申请尚需下单的数量，其他询价单可能已使用此需求。",
  dependency: "取消／归档前请处理未结询价单、关联采购单或收货单。",
  termsRequired: "选用前需完整价格、费用、有效期、交期、付款／运送条件及适用性审查。",
  expiredError: "报价有效期或承诺交货日已过，请记录更新报价。",
  orderLocked: "请使用 RFQ 采购单页面，不可直接修改已选定的商业条件。",
  unsaved: "未保存RFQ／报价变更将丢失。",
  rulesTitle: "适用规则",
  rulesDecided: "已于19/09/2026确定",
  rules: {
    collect: {
      title: "如何询价",
      body: "询价单由已审核的采购申请创建——全部或部分明细／数量，不超过尚需下单的数量。系统不会自动发信：由采购将询价单发给供应商，再记录收到的每份报价（各行价格、运费、税、有效期、交期、条款）。逾期报价在选定前仍可记录。有效期与交期按越南日期计算。"
    },
    compare: {
      title: "不只比较价格",
      body: "在同一币种内比较总成本（货款＋运费＋税）——不自动换算汇率；跨币种时由选定人记录依据。另考虑交期与需求日期（逾期会提示）、有效期、付款条件及适用性审查（质量、规格——须为“适合采购”才可选定；不取代 IQC）。系统不会自动选最便宜的一家。"
    },
    award: {
      title: "至少两份报价，有理由地选定",
      body: "选定须有至少 2 份合格报价；只有 1 份时，选定人须说明单一供应商理由——独家、急单、客户指定或只有一家回复。每张询价单选定一家供应商并创建一张采购单草稿；要分给多家供应商，请由同一采购申请创建多张询价单。选定其他供应商不会变更产品的默认供应商。"
    },
    authority: {
      title: "谁可以做什么",
      body: "“创建”可创建询价单及记录新报价；“编辑”可修改草稿、开始收集报价、修订报价及取消询价单；“审核”可选定报价并创建采购单草稿；“删除”可归档。生成的采购单依“采购单”菜单的勾选——确认采购单需要该菜单的“审核”。"
    }
  },
  singleSource: {
    label: "单一供应商理由",
    hint: "只有 {{count}} 份合格报价——至少需要 2 份才能比较。请选择只用一家供应商的理由：",
    exclusive: "独家——只有此供应商能做",
    urgent: "急单——来不及询问更多供应商",
    customerNominated: "客户指定供应商",
    onlyReply: "只有一家供应商回复"
  },
  singleSourceError: "合格报价少于 2 份：选定前请先选择单一供应商理由。",
  singleSourceNote: "单一供应商：{{reason}}",
  readyCount: "合格报价：{{count}}",
  lowest: "总额最低",
  groups: {
    info: "询价单",
    infoHint: "来源采购申请、报价截止日、发给供应商的参考／规格。",
    lines: "询价物料",
    linesHint: "采购申请尚需下单数量的全部或部分。",
    bids: "供应商报价",
    bidsHint: "按各币种的总成本排序，只有合格报价可选定。",
    terms: "报价",
    termsHint: "供应商、币种、日期、条款、运费及税。",
    review: "适用性审查",
    reviewHint: "质量／规格与需求比对——须为“适合采购”才可选定，不取代 IQC。",
    prices: "各行价格",
    pricesHint: "每询价单位的价格，以报价币种计。",
    order: "采购单",
    orderHint: "供应商、条款与明细依已选定报价——固定不变。",
    logistics: "物流与状态",
    logisticsHint: "预计／实际交期、备注、采购单状态。确认采购单需要“采购单”菜单的“审核”。"
  },
  choose: "选定",
  awardReason: "选定理由",
  openHint: "开始收集报价：询价单内容从此锁定，不可再修改。请填写原因——例如已将询价单发给哪些供应商。",
  archiveHint: "归档已选定或已取消的询价单以精简列表；内容与历史仍保留。",
};
